export default {
  name: 'Loading',
};
